import React from 'react';

import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';

interface FiltroCategoriaProps {
  label: string;
  opcoes: string[];
  selecionadas: string[];
  onChange: (valores: string[]) => void;
  open: boolean;
  onToggle: () => void;
}

/**
 * Uma categoria multi-select do sheet de filtros (UF, Subsistema, Conjunto...).
 *
 * Mesmo par `Section` + `OptionRow` que o painel de controle mobile usa — os
 * filtros do desktop sao dropdowns `BarraDeFiltros`, que nao cabem aqui.
 */
export default function FiltroCategoria({
  label, opcoes, selecionadas, onChange, open, onToggle,
}: FiltroCategoriaProps) {
  const alternar = (valor: string) => {
    onChange(
      selecionadas.includes(valor)
        ? selecionadas.filter((v) => v !== valor)
        : [...selecionadas, valor],
    );
  };

  return (
    <Section
      label={label}
      valueText={selecionadas.length > 0 ? `${selecionadas.length}` : undefined}
      open={open}
      onToggle={onToggle}
    >
      {opcoes.map((opcao) => (
        <OptionRow
          key={opcao}
          label={opcao}
          selected={selecionadas.includes(opcao)}
          onSelect={() => alternar(opcao)}
          selectionType="multiple"
        />
      ))}
    </Section>
  );
}
